import { render, staticRenderFns } from "./ViewsLayout.vue?vue&type=template&id=6b94047d&scoped=true&"
import script from "./ViewsLayout.vue?vue&type=script&lang=js&"
export * from "./ViewsLayout.vue?vue&type=script&lang=js&"
import style0 from "./ViewsLayout.vue?vue&type=style&index=0&id=6b94047d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94047d",
  null
  
)

export default component.exports